import { keepPreviousData, useQuery } from "@tanstack/react-query";

export const useReactQuery = (key, queryFn, config = {}) => {
  const { isLoading, isFetching, isError, isSuccess, data, refetch } = useQuery(
    {
      queryKey: key,
      queryFn: queryFn,
      placeholderData: keepPreviousData,
      cacheTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      ...config,
    }
  );

  return {
    isLoading,
    isFetching,
    isError,
    isSuccess,
    data,
    refetch,
  };
};
